import { z } from "zod";

const isValidEmail = (email: string) => {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

const isValidPhoneNumber = (value: string): boolean => {
  if (!value) return false;
  if (value.length < 10 || value.length > 11) return false;
  return value.split("").every((char) => char >= "0" && char <= "9");
};

export const updateProfileSchema = z.object({
  fullName: z
    .string()
    .min(1, "Họ và tên là bắt buộc")
    .min(2, "Họ và tên phải có ít nhất 2 ký tự")
    .max(100, "Họ và tên không được vượt quá 100 ký tự"),
  email: z
    .string()
    .min(1, "Email là bắt buộc")
    .refine((val) => isValidEmail(val), "Email không hợp lệ"),
  phone: z
    .string()
    .min(1, "Số điện thoại là bắt buộc")
    .refine((val) => isValidPhoneNumber(val), "Số điện thoại không hợp lệ"),
  city: z.string().min(1, "Vui lòng chọn Tỉnh/Thành phố"),
  ward: z.string().min(1, "Vui lòng chọn Phường/Xã"),
  gender: z.enum(["Nam", "Nữ", "Khác"]),
  dob: z
    .string()
    .min(1, "Vui lòng chọn ngày sinh")
    .refine(
      (val) => {
        const date = new Date(val);
        return !Number.isNaN(date.getTime());
      },
      { message: "Ngày sinh không hợp lệ" }
    )
    .refine(
      (val) => {
        const date = new Date(val);
        const today = new Date();
        const age = today.getFullYear() - date.getFullYear();
        const monthDiff = today.getMonth() - date.getMonth();
        const actualAge =
          monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())
            ? age - 1
            : age;
        return actualAge >= 6;
      },
      { message: "Bạn phải từ 6 tuổi trở lên để tham gia" }
    ),
});

export const profileSetupSchema = z.object({
  fullName: z
    .string()
    .min(1, "Họ và tên là bắt buộc")
    .min(2, "Họ và tên phải có ít nhất 2 ký tự")
    .max(100, "Họ và tên không được vượt quá 100 ký tự"),
  nickname: z
    .string()
    .min(1, "Biệt danh là bắt buộc")
    .min(2, "Biệt danh phải có ít nhất 2 ký tự")
    .max(50, "Biệt danh không được vượt quá 50 ký tự"),
  dateOfBirth: updateProfileSchema.shape.dob,
  gender: updateProfileSchema.shape.gender,
  city: updateProfileSchema.shape.city,
  ward: updateProfileSchema.shape.ward,
  avatar: z.string().optional(),
});

export type UpdateProfileForm = z.infer<typeof updateProfileSchema>;
export type ProfileSetupForm = z.infer<typeof profileSetupSchema>;
